import React, { useState } from 'react';

const Step6ButtSize = ({ onNext, currentData }) => {
  const [selected, setSelected] = useState(currentData?.extraFields?.buttSize || null);

  const options = [
    { value: 'small', label: 'Small', image: 'https://cdn.lovescape.com/cdn/front/images/marketing/page6-Small.webp' },
    { value: 'medium', label: 'Medium', image: 'https://cdn.lovescape.com/cdn/front/images/marketing/page6-Medium.webp' },
    { value: 'large', label: 'Large', image: 'https://cdn.lovescape.com/cdn/front/images/marketing/page6-Large.webp' },
    { value: 'huge', label: 'Huge', image: 'https://cdn.lovescape.com/cdn/front/images/marketing/page6-Huge.webp' }
  ];

  const handleSelect = (value) => {
    setSelected(value);
    setTimeout(() => {
      onNext({ 
        extraFields: { 
          ...currentData.extraFields, 
          buttSize: value 
        } 
      });
    }, 500);
  };

  return (
    <div className="step step-selection">
      <h2 className="step-title">What kind of butt catches your eyes the most?</h2>
      <div className="options-grid grid-2x2">
        {options.map(option => (
          <div
            key={option.value}
            className={`option-card ${selected === option.value ? 'selected' : ''}`}
            onClick={() => handleSelect(option.value)}
          >
            <img src={option.image} alt={option.label} className="option-image" />
            <div className="option-label">{option.label}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Step6ButtSize;